import { UtilityService } from './index'

class ReportServices {

    async getReport(filterData) {

        let result = await fetch(UtilityService.baseUrl() + 'api/report/' + filterData.reportType, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify(filterData)
        });
        return {
            status: result.status,
            text: await result.json()
        };

    }

    async getSampleType() {
        let result = await fetch(UtilityService.baseUrl() + 'api/report/getSampleType', {
            method: "GET",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            }
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async meetingNotesExcel(id) {
        let result = await fetch(UtilityService.baseUrl() + 'api/report/meetingNoteExcel', {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({ _id: id })
        });
        return {
            status: result.status,
            text: await result.json()
        };
    }

    async bulkUpdateProcess(obj) {
        let result = await fetch(UtilityService.baseUrl() + 'api/report/updateProcess', {
            method: "PUT",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'AuthToken': localStorage.getItem("authToken")
            },
            body: JSON.stringify({ ...obj })
        });
        let data = await result.json()
        return {
            status: result.status,
            text: data,
            message: data.message
        };
    }

}
export default new ReportServices();


// WEBPACK FOOTER //
// ./src/services/report.service.js